export const mod = (n: number, m: number) => ((n % m) + m) % m;
